// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"559":"6c5bb356","787":"a0a26fd5"}[chunkId] + ".chunk.js";
};